export default __webpack_public_path__ + "static/media/logo_white.e83ca60c.png";